// farbschema: dunkelgrau/schwarz (passt zur hoehle und zum alten system, anders als book.world),
// akzent ocker (stirnlampe). rot ist fuer das dev-system reserviert.
const primary = '#1c1c1c';

const theme = {
  palette: {
    primary: {
      main: primary,
    },
    secondary: {
      main: '#c8871a',
    },
  },
  props: {
    // passwort-manager (lastpass) und browser-autocomplete aus allen eingabefeldern (suchfelder, formulare) fernhalten;
    // das login-formular setzt eigene inputProps und bleibt damit fuer lastpass sichtbar
    MuiInputBase: {
      inputProps: {
        'data-lpignore': 'true',
        autoComplete: 'off',
      },
    },
  },
  overrides: {
    MuiButton: {
      // rahmen voll schwarz statt halbtransparent (wie die kleinen buttons im emk-web)
      outlinedPrimary: {
        border: '1px solid '+primary,
      },
    },
    // werkzeugleiste oben (filter, erstellen, export, zurueck, ...): text-buttons mit rahmen und abstand,
    // weil sie in der themen-farbe nicht mehr von normalem text zu unterscheiden sind.
    // in listen (auge, stift) und beim blaettern bleiben sie ohne rahmen (sonst zu schwer)
    RaTopToolbar: {
      root: {
        '& .MuiButton-textPrimary': {
          border: '1px solid '+primary,
          marginLeft: '0.5em',
        },
        '& .MuiButton-textPrimary.Mui-disabled': {
          borderColor: 'rgba(0, 0, 0, 0.12)',
        },
      },
    },
  },
};

// titelbalken und login-hintergrund auf dem dev-system (sonst gleich wie produktiv); null = wie produktiv
const testColor = '#D02628';

export { testColor };
export default theme;
